import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class RedirectUrlHandler implements IOptionHandler {
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    if (map.get(DeliveryOptionConstants.SHOW_REDIRECT_URL)) {
      const redirectUrl: string | undefined = this.getRedirectUrl(map.get(DeliveryOptionConstants.REDIRECT_URL));
      if (redirectUrl && this.isValidUrl(redirectUrl)) {
        const deliveryOption: DeliveryOption = new DeliveryOption(DeliveryOptionConstants.REDIRECT_URL);
        deliveryOption.addSetting('value', redirectUrl);
        provider.addDeliveryOption(deliveryOption);
      }
    }
  }

  private isValidUrl(value: string): boolean {
    try {
      const url = new URL(value);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (error) {
      //Do nothing
    }

    return false;
  }

  private getRedirectUrl(value: unknown): string | undefined {
    if (typeof value !== 'undefined' && typeof value === 'string') {
      const adjustedValue = (value as string).trim();
      return adjustedValue ? adjustedValue : undefined;
    }
    return undefined;
  }
}

export default RedirectUrlHandler;
